import Chip from '@mui/material/Chip'
import { friendlyUUID } from '@utils/StringFormatter'

const IdChip = ({ id }: { id: string }) => {
  return (
    <Chip
      label={friendlyUUID(id)}
      size="small"
      data-chromatic="ignore"
      sx={{
        fontWeight: 'bold',
        fontFamily: 'monospace',
        textTransform: 'lowercase',
      }}
      data-testid="id-chip"
    />
  )
}

export default IdChip
